module.exports = __webpack_public_path__ + "static/media/yp-how-to-date-step3.ba9492b7.webp";